/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/

import { IconProps } from "../../IconProps";
import { renderIcon } from "../../SvgIcon";
const iconType = {
  viewBox: "0 0 24 24",
  paths: [
    {
      d: "M3 2c.553 0 1 .448 1 1v17h17a.9991.9991 0 01.9933.8832L22 21c0 .553-.447 1-1 1H3c-.553 0-1-.447-1-1V3c0-.552.447-1 1-1zm5 12c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm4-4c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm3-5c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm5-3c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2z",
    },
  ],
  circles: [],
};

export const ChartProbabilityPlotIcon = (props: IconProps) =>
  renderIcon(props, iconType);
